import React from "react";

/**
 * Logos QUILLA - wordmarks tipográficos SVG.
 * Cuatro variantes según el uso: Logo (completo), Isotipo (marca Q sola).
 * Fácil de swappear por los SVG oficiales cuando el usuario los suba.
 */

const Q = ({ color = "#1F3864", accent = "#C9A227" }) => (
  <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    {/* Q estilizada — círculo con "quilla" (bandada náutica) atravesando */}
    <circle cx="32" cy="32" r="26" fill="none" stroke={color} strokeWidth="6" />
    <path d="M 40 44 L 56 60" stroke={accent} strokeWidth="7" strokeLinecap="round" />
    <path d="M 22 32 Q 32 22 42 32" stroke={color} strokeWidth="3" fill="none" strokeLinecap="round" opacity="0.65" />
  </svg>
);

export function IsotipoColor({ size = 32 }) {
  return <div style={{ width: size, height: size }}><Q color="#1F3864" accent="#C9A227" /></div>;
}
export function IsotipoBlanco({ size = 32 }) {
  return <div style={{ width: size, height: size }}><Q color="#ffffff" accent="#C9A227" /></div>;
}
export function IsotipoNavy({ size = 32 }) {
  return <div style={{ width: size, height: size }}><Q color="#1F3864" accent="#1F3864" /></div>;
}

/** Wordmark para login / documentos */
export function LogoQuilla({ variant = "color", size = 40 }) {
  const color = variant === "blanco" ? "#ffffff" : "#1F3864";
  const accent = variant === "navy" ? "#1F3864" : "#C9A227";
  return (
    <div className="inline-flex items-center gap-3" style={{ height: size }}>
      <div style={{ width: size, height: size }}><Q color={color} accent={accent} /></div>
      <div className="leading-none">
        <div style={{ color, fontFamily: "Manrope, sans-serif", fontWeight: 800, fontSize: size * 0.65, letterSpacing: "0.02em" }}>
          QUILLA
        </div>
        <div style={{ color: variant === "blanco" ? "rgba(255,255,255,0.7)" : "#6b7280", fontSize: size * 0.22, letterSpacing: "0.25em", fontFamily: "IBM Plex Mono, monospace", marginTop: 3 }}>
          CONTINUIDAD OPERATIVA
        </div>
      </div>
    </div>
  );
}
